import { useRedirect } from "../../hooks";
import { Map } from "../elements/";

import styles from "../../assets/styles/cherries.module.scss";
import image from "../../assets/images/cherries/cherries-1.jpg";

import { CherriesFormv2, Contact } from "../partials";
import laurent from "../../assets/images/cherries/overview/laurent.jpg";
import stephanie from "../../assets/images/cherries/overview/stephanie.jpg";

import { CHERRY_PHASE, CherryPhase } from "../../config";

/**
 * The intro text shown for each season phase. To change the copy for a
 * phase, edit it here; to switch which phase is live, change CHERRY_PHASE
 * in src/config.ts.
 */
const phaseContent: Record<CherryPhase, JSX.Element> = {
  recruiting: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      <p>
        Ben je 16 jaar of ouder, of ben je op zoek naar een flexijob, woon je in
        de streek van Sint-Jan-in-Eremo en heb je zin om te werken tussen de
        zoete kersen van begin juli tot begin augustus? Dan kan je bij ons aan
        de slag tijdens deze periode.
        <br />
        <br />
        Zowel studenten als flexi-jobbers kunnen ons helpen tijdens het
        kersenseizoen.
        <br />
        <br />
        Interesse? Neem dan gerust contact op via het nummer 0479/25.44.60 of{" "}
        <a href="/contact">klik hier</a> om contact op te nemen via het
        contactformulier.
      </p>
      <br />
      <br />
      Houd onze updates in de gaten voor meer informatie over het komende
      seizoen. We hopen u opnieuw te mogen verwelkomen en samen het
      kersenseizoen te beleven.
      <br />
      <br />
      <strong>Het Engelendael team</strong>
      <div className={styles.images}>
        <img src={stephanie} alt="Stephanie bij boer steven" />
        <img src={laurent} alt="Laurent bij delhaize" />
      </div>
    </p>
  ),
  preseason: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      {/* Werk de verwachte startdatum hieronder elk seizoen bij. */}
      Met enthousiasme kunnen we jullie melden dat we verwachten van start te
      gaan met het kersenseizoen <strong>eind juni 2026</strong>. We houden
      jullie op de hoogte via onze website en sociale media voor een exacte
      startdatum. Tot snel!
      <br />
      <br />
      <strong>Het Engelendael team</strong>
    </p>
  ),
  preorder: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      {/* Werk de startdatum hieronder elk seizoen bij. */}
      <strong>Vanaf 3 juli kunt u via onderstaand bestelformulier</strong>{" "}
      <strong>kersen reserveren</strong>. Uw geplaatste bestelling kan dan
      afgehaald worden in onze verkoopsruimte van Hoeve Engelendael. Naast
      online bestellen is het ook mogelijk om ons <strong>telefonisch</strong>{" "}
      te contacteren via <strong>0479 25 44 60</strong>, daarnaast is het ook
      mogelijk ter plaatse in de winkel kersen te kopen zolang de voorraad
      strekt.
      <br />
      <br />
      <strong>Het Engelendael team</strong>
    </p>
  ),
  active: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />U kunt via onderstaand bestelformulier{" "}
      <strong>kersen reserveren</strong>. Uw geplaatste bestelling kan nadien
      afgehaald worden in onze verkoopsruimte van Hoeve Engelendael. Naast
      online bestellen is het ook mogelijk om ons <strong>telefonisch</strong>{" "}
      te contacteren via <strong>0479 25 44 60</strong>. Daarnaast bent u ook
      welkom om ter plaatse in de winkel kersen te kopen zolang de voorraad
      strekt.
      <br />
      <br />
      <strong>Het Engelendael team</strong>
    </p>
  ),
  paused: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      Hartelijk bedankt voor jullie talrijke opkomst tijdens onze eerste
      verkoopdag afgelopen zondag 28 juni 2026.
      <br />
      <br />
      Door de extreme tropische temperaturen van de afgelopen dagen zijn wij
      sterk afhankelijk van het verdere rijpingsproces van de kersen. Om de
      kwaliteit van onze kersen te kunnen blijven garanderen, nemen wij daarom{" "}
      <strong>tijdelijk geen nieuwe bestellingen aan</strong>.
      <br />
      <br />
      Enkel reeds geplaatste bestellingen kunnen worden afgehaald op de
      afgesproken datum.
      <br />
      <br />
      Telefonisch blijven wij bereikbaar voor vragen. Nieuwe bestellingen kunnen
      wij momenteel pas opnieuw aannemen <strong>vanaf 15 juli</strong>, zowel
      telefonisch als online.
      <br />
      <br />
      Alvast bedankt voor jullie begrip. We kijken ernaar uit om jullie
      binnenkort opnieuw van heerlijke kersen te voorzien!
      <br />
      <br />
      <strong>Team Engelendael</strong>
    </p>
  ),
  closing: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      {/* Werk de datums hieronder elk seizoen bij. */}
      We zijn dit weekend (<strong>25 en 26 juli</strong>) volop bezig met de{" "}
      <strong>laatste pluk</strong> van dit seizoen. Door het grote aantal
      bestellingen kunnen we helaas <strong>geen vrije verkoop</strong> meer
      voorzien.
      <br />
      <br />
      Wij willen iedereen van harte bedanken voor het vertrouwen en voor de
      aankopen van dit seizoen. We kijken ernaar uit om jullie volgend jaar
      opnieuw te mogen verwelkomen.
      <br />
      <br />
      <strong>Team Engelendael 🍒</strong>
    </p>
  ),
  closed: (
    <p>
      <strong>Beste kersenklanten,</strong>
      <br />
      <br />
      Het <strong>kersenseizoen van 2026</strong> is inmiddels afgelopen. Het
      was een kort seizoen, maar we zijn blij dat we opnieuw mooie
      kwaliteitsvolle kersen mochten aanbieden en veel tevreden kersenklanten
      mochten verwelkomen.
      <br />
      <br />
      Wij willen iedereen van harte bedanken voor het vertrouwen en voor de
      aankopen van dit seizoen. We kijken ernaar uit om jullie volgend jaar
      opnieuw te mogen verwelkomen.
      <br />
      <br />
      <strong>Team Engelendael 🍒</strong>
    </p>
  ),
};

const Cherries = () => {
  const { redirect } = useRedirect();
  const showOrderForm =
    CHERRY_PHASE === "preorder" ||
    CHERRY_PHASE === "active" ||
    CHERRY_PHASE === "paused";
  const showOpeningHours =
    CHERRY_PHASE === "active" || CHERRY_PHASE === "closing";

  return (
    <main className={styles.main}>
      <div className={styles.imgContainer}>
        <img src={image} alt="" />
        <div
          className={styles.cta}
          onClick={() => redirect("/kersen/gallerij")}
        >
          <i className="fas fa-camera" />
          <span>Bekijk meer foto's hier</span>
        </div>
      </div>

      <section className={styles.info}>
        <h1 className="title">Onze kersen</h1>
        {phaseContent[CHERRY_PHASE]}
      </section>

      {showOpeningHours && (
        <section className={styles.openingHoursContainer}>
          <h2 className="title">Openingsuren</h2>
          <section className={styles.openingHours}>
            <div>
              <strong>Woensdag</strong>
              <span>13:00 - 18:00</span>
            </div>

            <div>
              <strong>Zaterdag</strong>
              <span>10:00 - 12:00</span>
              <span>13:00 - 18:00</span>
            </div>

            <div>
              <strong>Zondag</strong>
              <span>10:00 - 12:00</span>
              <span>13:00 - 18:00</span>
            </div>
          </section>
        </section>
      )}

      {showOrderForm && (
        <section id="cherriesForm" className={styles.cherriesForm}>
          <h2 className="title">Bestel uw kersen</h2>
          <CherriesFormv2 />
        </section>
      )}

      <Contact page="cherries" />
      <Map />
    </main>
  );
};

export default Cherries;
